import React from 'react'
import { Header } from 'components/Header'
import { Button, Flex } from '@workwhile/ui'
import { QueryStatus } from 'components/QueryStatus'
import { useNotificationTasksContextValue } from '../context/NotificationTasksProvider'

export const NotificationTasksHeader = () => {
  const { state, actions } = useNotificationTasksContextValue()

  return (
    <Header
      title="Highnote Notification Tasks"
      subTitle="Webhook event playground"
      rightContent={
        <Flex alignItems="center" gap={2}>
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
          <Button
            onClick={() => actions.handleRetrySelected()}
            loading={state.isRetrying}
            disabled={state.selectedIds.size === 0}
          >
            Retry Selected ({state.selectedIds.size})
          </Button>
        </Flex>
      }
    />
  )
}
